<template lang="pug">
md-input-container
  md-icon(md-iconset="fa fa-dollar-sign")
  label Price
  md-input(type='number', v-model='price', @input='onPriceUpdate')
</template>

<script>
  export default {
    props: {
      value: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        price: this.value
      };
    },
    methods: {
      onPriceUpdate(value) {
        this.$emit('input', parseFloat(value));
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.price = newValue;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/pricing/PriceInput.vue